import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import _ from "lodash";
import { BrowserRouter, Route } from "react-router-dom";
import MMTopPane from "../components/MMTopPane";
import MDSubBanner from "../components/MDSubBanner";
import POSyncManagement from "./POSyncManagement";
import MDLibrary from "../components/MDLibrary";
import SMDLibrary from "../components/SMDLibrary";
import GDLibrary from "../components/GDLibrary";
import MDDetail from "../components/MDDetailScreen";
import MDEdit from "../components/MDEdit";
import MDNewItem from "../components/MDNewItem";
import SMDNewItem from "../components/SMDNewItem";
import GDNewItem from "../components/GDNewItem";
import Report from "../components/Report";
import SMDEdit from "../components/SMDEdit";
import GDEdit from "../components/GDEdit";
import UsersList from "../components/UsersList";
import ErrorMessage from "../components/ErrorMessage";
import StaffPOUpdate from "../components/StaffPOUpdate";
import StaffPODetails from "../components/StaffPODetails";
import ClientDashboardLibrary from "../components/ClientDashboardLibrary";
import MMPLDashboard from "../components/MMPLDashboard";
import Certificates from "../components/Certificates";
import IHMMaintenanceRevision from "../components/IHMMaintenanceRevision";
import POHazardessMaterial from "../components/POHazardessMaterial";
import POView from "../components/POView";
import StaffPendingTasks from "../components/StaffPendingTasks";
import ShipDetails from "../components/ShipDetails";
import MMPLUpdateMDocSDoc from "../components/MMPLUpdateMDocSDoc";
import userRoles from "../helpers/role";
import UpdateIHMPart1Revision from "./UpdateIHMPart1Revision";
import SubBannerShip from "../components/SubBannerShip";
import SubBannerStaff from "../components/SubBannerStaff";
import PageLoader from "../Shared/PageLoader";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";
import ShipManagement from "./ShipManagement";
import ShipManagementDetail from "./ShipManagementDetail";
import ShipManagementEditItem from "./ShipManagementEdititem";
import ShipManagementNewItem from "./ShipManagementNewItem";
import PaintCoatingSystem from "./ManagePaintCoating";
import EquipmentMachinerySystem from "./ManageEquipmentMachinery";
import StructureHullSystem from "./ManageStructureHull";
import StoresSystem from "./ManageStore";
import ClientManagement from "./ClientManagement";
import ClientManagementDetail from "./ClientManagementDetail";
import ClientManagementAdd from "./ClientManagementAdd";
import ClientManagementEdit from "./ClientManagementEdit";
import FleetManager from "./FleetManager";
import FleetManagerManagementAdd from "./FleetManagerManagementAdd";
import FleetManagerManagementEdit from "./FleetManagerManagementEdit";
import TechSuperintendent from "./TechSuperintendent";
import TechSuperintentdentManagementAdd from "./TechSuperintentdentManagementAdd";
import TechSuperintentdentManagementEdit from "./TechSuperintentdentManagementEdit";
import TechExecutive from "./TechExecutive";
import TechExecutiveManagementAdd from "./TechExecutiveManagementAdd";
import TechExecutiveManagementEdit from "./TechExecutiveManagementEdit";
import EditFleetManager from "./EditFleetManager";
import EditTechSuperintendent from "./EditTechSuperintendent";
import EditTechExecutive from "./EditTechExecutive";
import StaffManagement from "./StaffManagement";
import StaffManagementDetail from "./StaffManagementDetail";
import StaffManagementEdit from "./StaffManagementEdit";
import StaffManagementAdd from "./StaffManagementAdd";
import FleetManagerManagement from "./FleetManagerManagement";
import FleetManagerManagementDetail from "./FleetManagerManagementCard";
import TechSuperintendentManagement from "./TechSuperintendentManagement";
import TechSuperintendentManagementDetail from "./TechSuperintendentManagementCard";
import TechExecutiveManagement from "./TechExecutiveManagement";
import TechExecutiveManagementDetail from "./TechExecutiveManagementCard";
import KeywordManagement from "./KeywordManagement";
import KeywordAdd from "./KeywordAdd";
import KeywordEdit from "./KeywordEdit";
import ExistKeywordManagement from "./ExistKeywordManagement";
import ExceptionManagement from "./ExceptionManagement";
import ExceptionAdd from "./ExceptionAdd";
import ExceptionEdit from "./ExceptionEdit";
import ManagePaintCoating from "./ManagePaintCoating";
import ManageEquipmentMachinery from "./ManageEquipmentMachinery";
import ManageStructureHull from "./ManageStructureHull";
import ManageStores from "./ManageStore";
import EditPaintCoating from "./EditPaintCoating";
import EditEquipmentMachinery from "./EditEquipmentMachinery";
import EditStructureHull from "./EditStructureHull";
import EditStores from "./EditStores";
import MaterialDeclarationCollect from "./MaterialDeclarationCollect";
import MaterialDeclarationAdmin from "./MaterialDeclarationAdmin";
import UserManagement from "./UserManagement";
import AddUser from "./AddUser";
import EditUser from "./EditUser";
import POValidationMDSDoc from "../components/POValidationMDSDoc";
import ShipViewReview from "./ShipViewReview";
import StaffPOValidation from "./StaffPOValidation";
import SixMonthReview from "./SixMonthReview";
import SixMonthReviewEdit from "./SixMonthReviewEdit";
import PurchaseOrders from "../components/PurchaseOrders";
import ShortClose from "../components/ShortClose";
import CheckUpdate from "../components/CheckUpdate";
import ChangePassword from "../components/ChangePassword";
import MMPLDashboardShip from "../components/MMPLDashboardShip";
import ShipDocument from "./ShipDocument";
import TEForms from "./TEForms";
import StaffOtherTask from "./StaffOtherTask";
import StaffOtherTaskEdit from "./StaffOtherTaskEdit";
import PriorityDashboard from "./PriorityDashboard";
import KPYDashboard from "./KPYDashboard";
import SpecialAccessManagement from "./SpecialAccessManagement";
import SpecialAccessManagementAdd from "./SpecialAccessManagementAdd";
import SpecialAccessManagementEdit from "./SpecialAccessManagementEdit";
import ViewIHMPart1Revision from "./ViewIHMPart1Revision";
import MMPLDashboardClient from "./MMPLDashboardClient";
import MdSdupload from "./MDoC&SDoCUpload/MdSdupload";
import POShips from "./MDoC&SDoCUpload/PurchaseOrders";
import MdSdUploadError from "./MDoC&SDoCUpload/MdSdUploadError";
import POViewHMV from "./POViewHMV";
import ConsultantDashboardLibrary from "./ConsultantDashboardLibrary";
import PoSyncdashboard from "./PoSyncDashboard/PoSyncdashboard";
import PoSyncShips from "./PoSyncDashboard/PoSyncShips";
import PoSyncHistory from "./PoSyncDashboard/PoSyncHistory";

let user = localStorage.getItem("UserRoles");

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rolename: "",
    };
  }

  // componentWillMount() {
  //   const { dispatch } = this.props;
  //   axios.interceptors.request.use(
  //     (config) => {
  //       dispatch(showLoader());
  //       const userDetails = localStorage.getItem("currentUser");
  //       let userToken = JSON.parse(userDetails);
  //       if (userToken) {
  //         config.headers["Authorization"] = "Bearer " + userToken.accessToken;
  //       }
  //       return config;
  //     },
  //     function (error) {
  //       dispatch(hideLoader());
  //       return Promise.reject(error);
  //     }
  //   );

  //   axios.interceptors.response.use(
  //     function (response) {
  //       dispatch(hideLoader());
  //       return response;
  //     },
  //     function (error) {
  //       dispatch(hideLoader());
  //       return Promise.reject(error);
  //     }
  //   );
  // }

  componentWillMount() {
    let activeRequests = 0;
    const { dispatch, match } = this.props;
    axios.interceptors.request.use(
      (config) => {
        activeRequests += 1;
        dispatch(showLoader());
        const userDetails = localStorage.getItem("currentUser");
        let userToken = JSON.parse(userDetails);
        if (userToken) {
          config.headers["Authorization"] = "Bearer " + userToken.accessToken;
        }
        return config;
      },
      function (error) {
        // dispatch(hideLoader());
        return Promise.reject(error);
      },
    );

    axios.interceptors.response.use(
      function (response) {
        activeRequests -= 1;
        if (activeRequests === 0) {
          dispatch(hideLoader());
        }
        return response;
      },
      function (error) {
        activeRequests -= 1;
        if (activeRequests === 0) {
          dispatch(hideLoader());
        }
        return Promise.reject(error);
      },
    );
  }

  componentDidMount() {
    //
    // var _this = this;
    // const user = JSON.parse(
    //   sessionStorage.getItem(
    //     `oidc.user:${process.env.REACT_APP_IDENTITY_CONFIG_AUTHORITY}:${process.env.REACT_APP_IDENTITY_CONFIG_CLIENT_ID}`
    //   )
    // ).profile;
    // _this.authService.getUserRole().then(function (userRole) {
    //   _this.props.dispatch({ type: "UserRole", data: userRole });
    //   _this.props.dispatch({ type: "AuthenticatedUserInformation", data: user });
    // })
    // const { user, history } = this.props;
    // const profile = user && user.profile.email;
    // console.log("user", profile);
    //  axios
    //  .get(`${API.COMMON_CONTROL}/User/${profile}`)
    //  .then(response => {
    //    const ports = response.data;
    //    this.setState({ userid: ports });
    //  })
    //  .catch(error => {
    //    console.log(error);
    //  });
    // axios
    // .get(`https://localhost:44397/api/UserRoles/LayoutRequest?email=${profile}`)
    // .then(response => {
    //   console.log(response,"layoutresponse");
    //  this.setState({rolename: response.data})
    // })
    // .catch(error => {
    //   console.log(error);
    // });
    // if (!user || user.expired) {
    //   history.push("/");
    // }
  }

  render() {
    const {
      showSidePane,
      IsSMDEdit,
      IsGDEdit,
      MMPLSidePanCollectDocs,
      ShowStaffPendingTaskPanel,
      editPOView,
      showPODetail,
      Role,
    } = this.props;
    // const history = createBrowserHistory();

    return (
      <>
        <BrowserRouter>
          {/* <Switch> */}
          {/* <Router history={history}>
          <Suspense fallback={<div>Loading ...</div>}> */}
          <Route path="/Home" component={MMTopPane}></Route>
          <Route
            path="/Home"
            render={() => {
              return window.location.href.indexOf("/Home/Ship") !==
                -1 ? null : (
                <Route path="/Home" component={MDSubBanner}></Route>
              );
            }}
          />
          {/* <MaterialDeclaration Old/> */}
          {/* <div className="row">
            <div className={`${showSidePane ? "col-sm-6 mobile" : "col-lg-12"} `}>
              <Route exact path="/Home" component={MDLibrary}></Route>
            </div>
            {showSidePane ? (
              <div className="col-sm-6">
                <Route path="/Home/MDDetail/:id" component={MDDetail}></Route>
              </div>
            ) : null}
          </div> */}

          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Route path="/Home/MDLibrary" component={MDLibrary}></Route>
            </div>
          </div>

          {/* <Route path="/Home/MDDetail/:id" component={MDDetail}></Route> */}

          <div className="row">
            <div className="col-lg-12">
              <Route path="/Home/SMDLibray" component={SMDLibrary}></Route>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <Route path="/Home/SMDEditItem/:id" component={SMDEdit}></Route>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <Route path="/Home/GDLibray" component={GDLibrary}></Route>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <Route path="/Home/GDEditItem/:id" component={GDEdit}></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Route
                path="/Home/MMPLDashboardShip/:id"
                component={MMPLDashboardShip}
              ></Route>
            </div>
          </div>

          {user == userRoles.client ? (
            <div className="row px-4">
              <div
                className={`${
                  editPOView || showPODetail
                    ? "col-sm-12 col-md-6 col-lg-6 mobile"
                    : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                } `}
              >
                <Route
                  path="/Home/ClientDashboard"
                  component={ClientDashboardLibrary}
                ></Route>
              </div>
              {editPOView ? (
                <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                  <Route
                    path="/Home/ClientDashboard/POUpdate/:id"
                    component={StaffPOUpdate}
                  ></Route>
                </div>
              ) : null}
              {showPODetail ? (
                <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                  <Route
                    path="/Home/ClientDashboard/StaffPODetails/:id"
                    component={StaffPODetails}
                  ></Route>
                </div>
              ) : null}
            </div>
          ) : null}
          {user == userRoles.consultant ? (
            <div className="row px-4">
              <div
                className={`${
                  editPOView || showPODetail
                    ? "col-sm-12 col-md-6 col-lg-6 mobile"
                    : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                } `}
              >
                <Route
                  path="/Home/SpecialAccess/ships/:id"
                  component={ClientDashboardLibrary}
                ></Route>
              </div>
              <div
                className={`${
                  editPOView || showPODetail
                    ? "col-sm-12 col-md-6 col-lg-6 mobile"
                    : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                } `}
              >
                <Route
                  path="/Home/SpecialAccess"
                  exact
                  component={ConsultantDashboardLibrary}
                ></Route>
              </div>
              {editPOView ? (
                <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                  <Route
                    path="/Home/ClientDashboard/POUpdate/:id"
                    component={StaffPOUpdate}
                  ></Route>
                </div>
              ) : null}
              {showPODetail ? (
                <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                  <Route
                    path="/Home/ClientDashboard/StaffPODetails/:id"
                    component={StaffPODetails}
                  ></Route>
                </div>
              ) : null}
            </div>
          ) : null}

          {user == userRoles.mmpl || user == userRoles.mmpladmin ? (
            <>
              <div className="row px-4" style={{ backgroundColor: "#FFFFFF" }}>
                {/* <div className={`${MMPLSidePanCollectDocs ? "col-sm-12 col-md-6 col-lg-6 mobile" : "col-sm-12 col-md-12 col-lg-12 col-lg-12"} `}> */}
                <div className="col-sm-12 col-md-12 col-lg-12 col-lg-12">
                  <Route
                    path="/Home/MMPLDashboard"
                    component={MMPLDashboard}
                  ></Route>
                </div>
                {/* {MMPLSidePanCollectDocs ? (
                  <div className="col-sm-12 col-md-12 col-lg-12 col-lg-12">                   
                    <Route path="/Home/MMPLDashboard/MDocSDoc/:id" component={MMPLUpdateMDocSDoc}></Route>
                  </div>
                ) : null} */}
              </div>
            </>
          ) : null}

          {user == userRoles.mmpl || user == userRoles.mmpladmin ? (
            <>
              <div className="row px-4">
                <div className="col-sm-12 col-md-12 col-lg-12 col-lg-12">
                  <Route
                    path="/Home/PriorityDashboard"
                    component={PriorityDashboard}
                  ></Route>
                </div>
              </div>
            </>
          ) : null}

          <Route
            path="/Home/Ship"
            render={() => {
              return user == userRoles.staff ? (
                <>
                  <Route
                    path="/Home/Ship/Staff"
                    component={SubBannerStaff}
                  ></Route>
                  <div className="row px-4">
                    <div
                      className={`${
                        ShowStaffPendingTaskPanel
                          ? "col-sm-12 col-md-6 col-lg-6 new"
                          : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                      } `}
                    >
                      <Route
                        path="/Home/Ship/Staff"
                        component={ShipDetails}
                      ></Route>
                      <Route
                        path="/Home/Ship/Staff/Tasks"
                        component={StaffPendingTasks}
                      ></Route>
                    </div>
                    {/* {ShowStaffPendingTaskPanel ? (
                    <div className="col-sm-12 col-md-6 col-lg-6">
                      <Route path="/Home/Ship/Staff/Tasks/POUpdate" component={StaffPOUpdate}></Route>
                    </div>
                  ) : null} */}
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/Staff/MaintenanceRevision"
                        component={IHMMaintenanceRevision}
                      ></Route>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/Staff/MaterialValidation"
                        component={POHazardessMaterial}
                      ></Route>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/Staff/Certificates"
                        component={Certificates}
                      ></Route>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/staff/ShipDocument"
                        component={ShipDocument}
                      ></Route>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/staff/TEForms"
                        component={TEForms}
                      ></Route>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <Route path="/Home/Ship" component={SubBannerShip}></Route>
                  <div className="row px-4">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-lg-12">
                      <Route
                        path="/Home/Ship/:shipId"
                        component={ShipDetails}
                      ></Route>
                      <Route
                        path="/Home/Ship/:shipId/Tasks"
                        component={StaffPendingTasks}
                      ></Route>
                      <Route
                        path="/Home/Ship/:shipId/Othertask"
                        component={StaffOtherTask}
                      ></Route>
                      <Route
                        path="/Home/Ship/:shipId/OthertaskEdit"
                        component={StaffOtherTaskEdit}
                      ></Route>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/:id/MaintenanceRevision"
                        component={IHMMaintenanceRevision}
                      ></Route>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/:id/MaterialValidation"
                        component={POHazardessMaterial}
                      ></Route>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/:id/Certificates"
                        component={Certificates}
                      ></Route>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/:id/ShipDocument"
                        component={ShipDocument}
                      ></Route>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Route
                        path="/Home/Ship/:id/TEForms"
                        component={TEForms}
                      ></Route>
                    </div>
                  </div>
                </>
              );
            }}
          />

          {user == userRoles.mmpl || user == userRoles.mmpladmin ? (
            <div className="row px-4">
              <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
                <Route
                  path="/Home/Ship/:id/SixMonthReview"
                  component={SixMonthReview}
                ></Route>
              </div>
              {showSidePane ? (
                <div className="col-lg-6">
                  <Route
                    path="/Home/Ship/:id/SixMonthReview/:id"
                    component={ShipViewReview}
                  ></Route>
                </div>
              ) : null}
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Route
                  path="/Home/Ship/:id/SixMonthReviewEdit"
                  component={SixMonthReviewEdit}
                ></Route>
              </div>
            </div>
          ) : null}

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/Ship"
                component={ShipManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/Ship/:id"
                  component={ShipManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route path="/Home/MdocSdocUpload" component={MdSdupload}></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/MdocSdocUpload/:id"
                  component={POShips}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className={`col-lg-12`}>
              <Route
                path="/Home/MdocSdocUploadExceptions"
                component={MdSdUploadError}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/Management/ShipEdit/:id"
                component={ShipManagementEditItem}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/ShipEdit/:id/PaintCoating"
                  component={EditPaintCoating}
                ></Route>
                <Route
                  path="/Home/Management/ShipEdit/:id/EquipmentMachinery"
                  component={EditEquipmentMachinery}
                ></Route>
                <Route
                  path="/Home/Management/ShipEdit/:id/StructureHull"
                  component={EditStructureHull}
                ></Route>
                <Route
                  path="/Home/Management/ShipEdit/:id/Stores"
                  component={EditStores}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/Management/ShipAdd"
                component={ShipManagementNewItem}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/ShipAdd/PaintCoating"
                  component={ManagePaintCoating}
                ></Route>
                <Route
                  path="/Home/Management/ShipAdd/EquipmentMachinery"
                  component={ManageEquipmentMachinery}
                ></Route>
                <Route
                  path="/Home/Management/ShipAdd/StructureHull"
                  component={ManageStructureHull}
                ></Route>
                <Route
                  path="/Home/Management/ShipAdd/Stores"
                  component={ManageStores}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/Client"
                component={ClientManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/Client/:id"
                  component={ClientManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/ClientAdd"
                component={ClientManagementAdd}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/ClientAdd/FleetManager"
                  component={FleetManager}
                ></Route>
                <Route
                  path="/Home/Management/ClientAdd/TechSuperintendent"
                  component={TechSuperintendent}
                ></Route>
                <Route
                  path="/Home/Management/ClientAdd/TechExecutive"
                  component={TechExecutive}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/ClientEdit/:id"
                component={ClientManagementEdit}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/ClientEdit/:id/FleetManager"
                  component={EditFleetManager}
                ></Route>
                <Route
                  path="/Home/Management/ClientEdit/:id/TechSuperintendent"
                  component={EditTechSuperintendent}
                ></Route>
                <Route
                  path="/Home/Management/ClientEdit/:id/TechExecutive"
                  component={EditTechExecutive}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/SpecialAccess"
                component={SpecialAccessManagement}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/SpecialAccessAdd"
                component={SpecialAccessManagementAdd}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/SpecialAccessEdit/:id"
                component={SpecialAccessManagementEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/FleetManager"
                component={FleetManagerManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/FleetManager/:id"
                  component={FleetManagerManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/FleetManagerAdd"
                component={FleetManagerManagementAdd}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/FleetManagerEdit/:id"
                component={FleetManagerManagementEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/TechSuperintendent"
                component={TechSuperintendentManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/TechSuperintendent/:id"
                  component={TechSuperintendentManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/TechSuperintendentAdd"
                component={TechSuperintentdentManagementAdd}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/TechSuperintendentEdit/:id"
                component={TechSuperintentdentManagementEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/TechExecutive"
                component={TechExecutiveManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/TechExecutive/:id"
                  component={TechExecutiveManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/TechExecutiveAdd"
                component={TechExecutiveManagementAdd}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/TechExecutiveEdit/:id"
                component={TechExecutiveManagementEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/Staff"
                component={StaffManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/Staff/:id"
                  component={StaffManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/StaffAdd"
                component={StaffManagementAdd}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/StaffEdit/:id"
                component={StaffManagementEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/Keyword"
                component={KeywordManagement}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/POSyncException"
                component={POSyncManagement}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/POSyncDashboard"
                component={PoSyncdashboard}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/POSyncDashboardShips/:id"
                component={PoSyncShips}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/POSyncHistory/:id"
                component={PoSyncHistory}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/AddKeyword"
                component={KeywordAdd}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/EditKeyword/:id"
                component={KeywordEdit}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/ExistKeyword"
                component={ExistKeywordManagement}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/Exception"
                component={ExceptionManagement}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/KPIDashboard" component={KPYDashboard}></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/AddException"
                component={ExceptionAdd}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/EditException/:id"
                component={ExceptionEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/User"
                component={UserManagement}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/AddUser"
                component={AddUser}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/EditUser/:id"
                component={EditUser}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div
              className={`${
                ShowStaffPendingTaskPanel
                  ? "col-sm-12 col-md-6 col-lg-6 new"
                  : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
              } `}
            >
              <Route
                path="/Home/Staff/POValidation/:shipId/:poId"
                component={StaffPOValidation}
              ></Route>
            </div>
            {ShowStaffPendingTaskPanel ? (
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Route
                  path="/Home/Staff/POValidation/:shipId/:poId/update"
                  component={StaffPOUpdate}
                ></Route>
              </div>
            ) : null}
          </div>

          <Route
            path="/Home/MDCollect/:lineItemId"
            component={MaterialDeclarationCollect}
          ></Route>
          <Route
            exact
            path="/Home/MDAdmin/:mdId"
            component={MaterialDeclarationAdmin}
          ></Route>
          <Route
            exact
            path="/Home/MDAdmin"
            component={MaterialDeclarationAdmin}
          ></Route>
          {/* <Route path="/Home/MaterialDeclaration" component={MaterialDeclaration}></Route> */}
          <Route
            path="/Home/POView/:shipid/:poid"
            component={POViewHMV}
          ></Route>
          <Route
            path="/Home/POViewEdit/:shipid/:poid"
            component={POView}
          ></Route>
          <Route
            path="/Home/POViewRead/:shipid/:poid/:type"
            component={POView}
          ></Route>
          <Route
            path="/Home/PurchaseOrders/:shipid/:poid"
            component={PurchaseOrders}
          ></Route>
          <Route
            path="/Home/ShortClose/:shipid/:poid"
            component={ShortClose}
          ></Route>
          <Route
            path="/Home/POValidationMDSDoc/:shipid/:poid"
            component={POValidationMDSDoc}
          ></Route>
          <Route path="/Home/MDEdit/:id" component={MDEdit}></Route>
          <Route path="/Home/MDNewItem" component={MDNewItem}></Route>
          <Route path="/Home/SMDNewItem" component={SMDNewItem}></Route>
          <Route path="/Home/GDNewItem" component={GDNewItem}></Route>
          <Route path="/Home/Report" component={Report}></Route>
          {/* <Route path="/Home/Users" component={UsersList}></Route> */}
          <Route path="/Error" component={ErrorMessage}></Route>
          <Route
            path="/Home/IHMPart1/:shipid/:poid"
            component={UpdateIHMPart1Revision}
            exact
          ></Route>
          <Route
            path="/Home/IHMPart1/:shipid/:poid/view"
            exact
            component={ViewIHMPart1Revision}
          ></Route>
          <Route path="/Home/CheckUpdate/:poid" component={CheckUpdate}></Route>
          <Route
            exact
            path="/Home/ChangePassword"
            component={ChangePassword}
          ></Route>
          <div className="row px-4" style={{ backgroundColor: "#FFFFFF" }}>
            {/* <div className={`${MMPLSidePanCollectDocs ? "col-sm-12 col-md-6 col-lg-6 mobile" : "col-sm-12 col-md-12 col-lg-12 col-lg-12"} `}> */}
            <div className="col-sm-12 col-md-12 col-lg-12 col-lg-12">
              <Route
                path="/Home/MMPLDashboardClient/:id"
                component={MMPLDashboardClient}
              ></Route>
            </div>
            {/* {MMPLSidePanCollectDocs ? (
                  <div className="col-sm-12 col-md-12 col-lg-12 col-lg-12">                   
                    <Route path="/Home/MMPLDashboard/MDocSDoc/:id" component={MMPLUpdateMDocSDoc}></Route>
                  </div>
                ) : null} */}
          </div>

          <PageLoader />
          {/* <Route component={UnautherizeContent} ></Route> */}
          {/* </Suspense>
        </Router> */}
          {/* </Switch> */}
        </BrowserRouter>
      </>
    );

    // return <AdminLayoutContent />;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  // const {oidcReducer, viewActionReducer, LayoutReducer} = state;
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    SubBannerTitle: state.SubBannerrTitle || "MD Library",
    ShowMISidePan: state.ShowMISidePan || false,
    ShowRDSidePan: state.ShowRDSidePan || false,
    ShowEURegSidePan: state.ShowEURegSidePan || false,
    isAttachment: state.SidePanReducer.isAttachment
      ? state.SidePanReducer.isAttachment
      : false,
    IsSMDEdit: state.SidePanReducer.IsSMDEdit,
    IsGDEdit: state.SidePanReducer.IsGDEdit,
    editPOView: state.SidePanReducer.EditPOView || false,
    ShowStaffPendingTaskPanel:
      state.SidePanReducer.ShowStaffPendingTaskPanel || false,
    showPODetail: state.SidePanReducer.ShowPODetail || false,
    editPendingTaskPresence:
      state.SidePanReducer.EditPendingTaskPresence || false,
    editPendingTaskRevision:
      state.SidePanReducer.EditPendingTaskRevision || false,
    // isAuthenticated: state.SidePanReducer.isAuthenticated,
    Role: state.SidePanReducer.UserRole || null,
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
  };

  // return {
  //   // showSidePane: viewActionReducer.showSidePane || false,
  //   // backArrowUrl: viewActionReducer.backArrowUrl || "",
  //   // user: oidcReducer && oidcReducer.user ? oidcReducer.user : null,
  //   // Rolename: (LayoutReducer && LayoutReducer.rolename) || "",
  //   // inprogress: (LayoutReducer && LayoutReducer.inprogress) || false,
  // };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
